<template>
  <div @click="handleSessionClick" class="wrapper">
    <div class="overlay" @click="showSearch = false" v-if="showSearch"></div>
    <h2 v-if="showRanking" class="level">{{ "0" + (index + 1) }}</h2>
    <div class="title">
      {{ sessionTitle }}
    </div>
    <div class="corner-profile">
      <div  v-if="false" style="width: 100px;">
          <img
              v-if="imgURL"
              @click="handleSessionClick"
              :src="imgURL"
              :alt="`${bloggerFullname} picture`"
          />
          <b-card
              v-else
              bg-variant="default"
              text-variant="white"
              class="text-center"
          >
            <b-card-text>Cover not available</b-card-text>
          </b-card>
      </div>
      <h4 @click="handleSessionClick" class="description">
        <tip-tap-output
            v-if="sessionDescription"
            :content="sessionDescription"
            :use-dots="true"
        />
      </h4>
      <!-- remove ability to collect for now -->
      <button
        v-if="user && false"
        class="btn btn-follow"
        :class="isFollowed ? 'followed' : ''"
        @click.stop="handleCollectCornerSession"
      >
        <span v-if="!isFollowed">Collected</span>
        <span v-else>Collect</span>
      </button>
    </div>
    <div class="details">
      <div class="categories">
        <span class="ico ico-spiritual" v-if="true">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M9.26658 -0.104764C9.1645 -0.106395 9.06617 -0.0665622 8.99449 0.00617632L7.07606 1.91385C7.0062 1.9837 6.94215 2.05878 6.87764 2.13354C6.16411 1.54075 5.2691 1.20768 4.339 1.20843H3.4835C3.27485 1.20843 3.103 1.38036 3.103 1.58902V3.0478H1.64422C1.43557 3.0478 1.26404 3.21932 1.26404 3.42797V4.28345C1.26412 4.57004 1.30345 4.85459 1.36449 5.13446C1.10749 5.29573 0.863983 5.47839 0.649553 5.69328L0.0617934 6.28103C-0.085702 6.42857 -0.085702 6.67111 0.0617934 6.81865L1.9942 8.75139C2.06237 8.81958 2.13555 8.8817 2.20818 8.94434C1.6035 9.66125 1.2633 10.5652 1.26404 11.5056V12.3611C1.26406 12.5697 1.43557 12.7413 1.64422 12.7413H3.103V14.2C3.103 14.4087 3.27495 14.5806 3.4836 14.5806H4.339C4.63747 14.5805 4.93343 14.5383 5.22433 14.4721C5.38352 14.7243 5.56325 14.9634 5.7743 15.1744L6.364 15.7794C6.43482 15.852 6.53174 15.8933 6.63321 15.8941H6.63568C6.73614 15.8941 6.83275 15.8543 6.904 15.7835L8.82345 13.8752V13.8748C8.89312 13.8049 8.95718 13.73 9.02152 13.6552C9.73518 14.2483 10.6301 14.5813 11.5605 14.5805H12.4159C12.6246 14.5805 12.7964 14.4087 12.7964 14.2V12.7412H14.2553C14.4639 12.7412 14.6354 12.5697 14.6354 12.3611V11.5052C14.6354 11.2187 14.596 10.9344 14.535 10.6546C14.792 10.4933 15.0352 10.3108 15.2496 10.096L15.8377 9.50792C15.9852 9.36038 15.9852 9.11758 15.8377 8.97004L13.9052 7.03731C13.8371 6.96921 13.7639 6.90722 13.6913 6.84461C14.296 6.12771 14.6362 5.22382 14.6354 4.28342V3.42794C14.6354 3.21929 14.4639 3.04777 14.2553 3.04777H12.7964V1.58891C12.7964 1.38025 12.6246 1.2084 12.4159 1.2084H11.5605C11.262 1.20843 10.9657 1.25065 10.6748 1.31681C10.5159 1.06502 10.3368 0.826276 10.1261 0.615598L10.1243 0.614521L9.53458 0.00961071C9.46388 -0.0629536 9.36697 -0.10391 9.26567 -0.104858L9.26658 -0.104764ZM9.25895 0.81589L9.58319 1.14837L9.58596 1.15123C10.8465 2.41468 10.8464 4.4565 9.58596 5.72003L9.21716 6.08876C8.95124 5.9016 8.64992 5.77638 8.32962 5.72028V5.1999C8.32962 4.27568 8.00245 3.38568 7.41629 2.67394C7.47939 2.59807 7.54303 2.5226 7.61277 2.45273V2.45246L9.25895 0.81589ZM3.86337 1.96919H4.33834C6.12319 1.9711 7.56703 3.41504 7.56902 5.19989V5.72255C6.7502 5.86811 6.09213 6.45517 5.84606 7.2471C4.65524 6.74082 3.86667 5.58496 3.86337 4.28345V4.28308V1.96919ZM11.5605 1.96919H12.0358V3.0478H11.5605C11.4627 3.04787 11.3649 3.05554 11.2674 3.0627C11.2346 2.70691 11.1524 2.35892 11.0262 2.0248C11.2031 1.99513 11.3809 1.96925 11.5605 1.96921V1.96919ZM2.02441 3.80815H3.1027V4.28345C3.1027 4.37297 3.10971 4.46064 3.11577 4.54856C2.75886 4.57928 2.40952 4.65986 2.07401 4.78507C2.04791 4.61885 2.02452 4.45183 2.02444 4.28345L2.02441 3.80815ZM11.5605 3.80815H13.8748V4.28345C13.8729 6.06819 12.4291 7.51197 10.6444 7.51415H10.1237C10.0675 7.19376 9.94281 6.89224 9.75554 6.6263L10.1237 6.25815V6.25778C10.7793 5.60577 11.1775 4.74412 11.2658 3.82594C11.3637 3.81688 11.4618 3.80831 11.5602 3.80811L11.5605 3.80815ZM3.24576 5.30007C3.49135 6.21989 4.05912 7.00927 4.8371 7.5504C4.07378 7.63088 3.35003 7.92328 2.7517 8.40873C2.67626 8.34601 2.6013 8.28277 2.53175 8.21351L0.86826 6.54967L1.18737 6.23048C1.73653 5.6772 2.46952 5.35116 3.24543 5.30007H3.24576ZM7.9551 6.43192C8.00691 6.43251 8.05851 6.43612 8.10979 6.44227C8.24651 6.45868 8.38051 6.49411 8.50778 6.54682C9.01683 6.75766 9.40841 7.23954 9.40841 7.89441C9.40657 8.70106 8.75624 9.3521 7.94964 9.3532C7.29476 9.3532 6.81252 8.96196 6.6017 8.45289C6.39087 7.94383 6.45503 7.32616 6.91804 6.86315C7.22188 6.55931 7.59244 6.42722 7.9551 6.43193V6.43192ZM13.1474 7.38033H13.1475C13.2229 7.44305 13.2979 7.50629 13.3674 7.57555L15.0313 9.23905L14.7118 9.5585C14.1626 10.1117 13.4296 10.4378 12.6537 10.489C12.4082 9.56923 11.8403 8.7798 11.0624 8.23866C11.8257 8.1582 12.5494 7.86579 13.1477 7.38033H13.1474ZM5.25479 8.27491H5.25487H5.77524C5.83136 8.59522 5.95646 8.89654 6.14365 9.16243L5.7755 9.53091C5.11975 10.1829 4.72139 11.0444 4.63305 11.9628C4.53502 11.9718 4.4368 11.9804 4.33834 11.9806H2.02441V11.5056C2.02626 9.7209 3.47013 8.27714 5.25479 8.27491V8.27491ZM10.0531 8.54188C11.244 9.04822 12.0326 10.204 12.0358 11.5056V13.8199H11.5605C9.77566 13.8178 8.33181 12.374 8.3298 10.5892V10.0665C9.14876 9.92105 9.80703 9.33391 10.0531 8.54188ZM6.68153 9.70031C6.9475 9.88754 7.24896 10.0126 7.56937 10.0687V10.5892C7.56937 11.5132 7.89637 12.4031 8.48237 13.1148C8.41936 13.1907 8.35585 13.2664 8.28624 13.3363L6.64023 14.9732L6.31439 14.6388C6.31439 14.6391 6.31439 14.6382 6.31439 14.6384V14.638V14.6376C5.05178 13.375 5.05178 11.3316 6.31439 10.0689L6.68153 9.70031ZM13.8251 11.0037C13.8512 11.17 13.8747 11.3371 13.8748 11.5056V11.9806H12.7965V11.5056C12.7965 11.416 12.7895 11.3282 12.7834 11.2402C13.1404 11.2095 13.4895 11.1289 13.8251 11.0037H13.8251ZM4.63181 12.7263C4.66451 13.0821 4.74642 13.4301 4.87267 13.7642C4.69579 13.7938 4.51816 13.8198 4.33866 13.8199H3.86345V12.7413H4.33866C4.43651 12.7412 4.53422 12.7335 4.63181 12.7263V12.7263Z"
                fill="#A1B1BA"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <span class="ico ico-health" v-if="isHealth">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.42445 1.23083C3.20077 1.23083 2.07729 1.7187 1.25741 2.60519C0.447254 3.48128 0 4.67919 0 5.97995C0 7.31808 0.498278 8.54108 1.57727 9.83907C2.54263 11.0003 3.93499 12.184 5.54929 13.5554C5.55019 13.5561 5.5511 13.5568 5.55195 13.5576C6.10256 14.0253 6.7265 14.556 7.37413 15.1205C7.53604 15.2619 7.7439 15.3394 7.95955 15.3394C8.17504 15.3394 8.38311 15.2617 8.54492 15.1205C9.194 14.5546 9.81881 14.0235 10.3704 13.555C11.9845 12.1837 13.3767 11 14.3421 9.8387C15.4211 8.54082 15.9197 7.31807 15.9197 5.97995C15.9197 4.67919 15.4724 3.48128 14.6623 2.60519C13.8424 1.7187 12.7189 1.23083 11.4953 1.23083C10.5813 1.23083 9.74634 1.51833 9.00906 2.08679C8.63688 2.37373 8.29931 2.72511 8.00136 3.13568C7.99655 3.14225 7.99028 3.14758 7.983 3.15126C7.97573 3.15495 7.96766 3.15687 7.9595 3.15687C7.95134 3.15687 7.94332 3.15495 7.93604 3.15126C7.92877 3.14758 7.92245 3.14225 7.91764 3.13568C7.6198 2.72511 7.28237 2.37372 6.91031 2.08679C6.17303 1.51833 5.33815 1.23083 4.42413 1.23083H4.42445ZM4.42445 2.06336C5.14757 2.06336 5.8138 2.29359 6.39944 2.74505C6.92162 3.14765 7.28306 3.65423 7.49527 4.00884C7.59426 4.17419 7.76696 4.27207 7.95982 4.27207C8.15268 4.27207 8.32538 4.17419 8.42437 4.00884C8.63667 3.65425 8.99815 3.14765 9.5202 2.74505C10.1058 2.2936 10.772 2.06336 11.4952 2.06336C12.4811 2.06336 13.3893 2.45648 14.0486 3.16936C14.7177 3.89293 15.0849 4.89149 15.0849 5.97995C15.0849 7.12899 14.6542 8.15963 13.6997 9.30785C12.777 10.4178 11.4102 11.5781 9.82942 12.9213C9.27566 13.3916 8.64822 13.9248 7.99251 14.4941C7.98305 14.5023 7.97092 14.5069 7.95835 14.5069C7.94579 14.5069 7.93365 14.5023 7.9242 14.4941C7.27333 13.9267 6.64822 13.3951 6.0961 12.9261L6.09312 12.9239C6.09222 12.9232 6.09131 12.9224 6.09046 12.9217C4.50953 11.5785 3.14249 10.4178 2.2198 9.30786C1.26524 8.15965 0.834588 7.129 0.834588 5.97996C0.834588 4.8915 1.20183 3.89294 1.87095 3.16937C2.53031 2.4565 3.43825 2.06337 4.42431 2.06337L4.42445 2.06336Z"
              fill="#A1B1BA"
            />
          </svg>
        </span>
        <span class="ico ico-education" v-if="isEducation">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.83299 14.25C1.55684 14.25 1.33301 14.0261 1.33301 13.75V2.0625C1.33301 0.92522 2.25825 0 3.39554 0H13.6604C13.9366 0 14.1604 0.223875 14.1604 0.499999V12C14.1604 12.2761 13.9366 12.5 13.6604 12.5C13.3843 12.5 13.1604 12.2761 13.1604 12V0.999998H3.39554C2.80966 0.999998 2.33303 1.47663 2.33303 2.0625V13.75C2.33303 14.0261 2.10915 14.25 1.83299 14.25V14.25Z"
              fill="#A1B1BA"
            />
            <path
              d="M13.6604 16H3.58302C2.34236 16 1.33301 14.9907 1.33301 13.75C1.33301 12.5093 2.34236 11.5 3.58302 11.5H13.6604C13.9366 11.5 14.1604 11.7239 14.1604 12C14.1604 12.2761 13.9366 12.5 13.6604 12.5H3.58302C2.89377 12.5 2.33303 13.0608 2.33303 13.75C2.33303 14.4393 2.89377 15 3.58302 15H13.6604C13.9366 15 14.1604 15.2239 14.1604 15.5C14.1604 15.7761 13.9366 16 13.6604 16V16Z"
              fill="#A1B1BA"
            />
            <path
              d="M13.6604 14.25H3.58299C3.30684 14.25 3.08301 14.0261 3.08301 13.75C3.08301 13.4739 3.30684 13.25 3.58299 13.25H13.6604C13.9365 13.25 14.1603 13.4739 14.1603 13.75C14.1603 14.0261 13.9365 14.25 13.6604 14.25Z"
              fill="#A1B1BA"
            />
            <path
              d="M4.08299 12.5C3.80686 12.5 3.58301 12.2761 3.58301 12V0.499999C3.58301 0.223875 3.80686 0 4.08299 0C4.35915 0 4.58298 0.223875 4.58298 0.499999V12C4.58298 12.2761 4.35915 12.5 4.08299 12.5Z"
              fill="#A1B1BA"
            />
          </svg>
        </span>
        <span class="ico ico-finance" v-if="isFinance">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.57129 0.592529C2.64516 0.596591 1.89356 1.34214 1.87837 2.26855H1.69992C0.764337 2.26855 0.00410311 3.02468 0 3.96029C0 3.96037 0 3.96041 0 3.96049V13.1108C0 13.1109 0 13.1109 0 13.111C0.00409393 14.0465 0.760108 14.8106 1.69973 14.8147H12.142C13.0681 14.8107 13.8197 14.0651 13.8349 13.1387H14.0134C14.9489 13.1387 15.7092 12.3826 15.7133 11.447C15.7133 11.4469 15.7133 11.4469 15.7133 11.4468V2.29636C15.7133 2.29629 15.7133 2.29623 15.7133 2.29617C15.7092 1.35682 14.953 0.596632 14.0135 0.59253H3.57129V0.592529ZM3.57129 1.48624H3.57176H14.0136C14.4586 1.49021 14.8161 1.8514 14.8199 2.29672V4.22342L13.838 5.48884V3.96047C13.838 3.02475 13.0777 2.26855 12.1421 2.26855H2.772C2.78684 1.83663 3.13591 1.49012 3.57139 1.48624H3.57129ZM1.69973 3.16226H12.142C12.5833 3.16226 12.9442 3.51552 12.9442 3.96047V6.20065C12.8886 6.21071 12.8327 6.21918 12.7805 6.21918H10.4779C9.19893 6.21918 8.15946 7.25865 8.15946 8.53759C8.15946 9.81652 9.19883 10.856 10.4777 10.8601H12.7763C12.7772 10.8601 12.778 10.8601 12.7789 10.8601C12.8342 10.857 12.8874 10.8507 12.9401 10.8448L12.944 13.1109C12.944 13.5559 12.5868 13.917 12.1418 13.921H1.69993H1.69946C1.25459 13.917 0.897216 13.5559 0.893252 13.1108V3.96092V3.96046C0.897253 3.51944 1.2544 3.16225 1.69946 3.16225L1.69973 3.16226ZM14.8159 5.6841L14.8197 7.96671L13.5806 9.57395C13.3902 9.82142 13.0927 9.96656 12.7799 9.97037H10.4781H10.4777C9.68939 9.96636 9.05298 9.32978 9.05298 8.54159C9.05298 7.75339 9.68938 7.1169 10.4777 7.11289H12.7763C13.0584 7.11289 13.3367 7.05163 13.5907 6.9288L13.5912 6.92861C13.8615 6.80157 14.0986 6.60933 14.2826 6.37217V6.37209L14.8159 5.6841ZM10.4141 8.09473C10.1685 8.09473 9.96723 8.29602 9.96723 8.54159C9.96723 8.78716 10.1685 8.98844 10.4141 8.98844H11.3718C11.6173 8.98844 11.8186 8.78716 11.8186 8.54159C11.8186 8.29602 11.6173 8.09473 11.3718 8.09473H10.4141ZM14.8197 9.42748V11.4468C14.8157 11.8878 14.4586 12.245 14.0135 12.245H13.8379V10.528C14.0048 10.4122 14.157 10.2725 14.2858 10.1164C14.2862 10.116 14.2865 10.1156 14.2868 10.1152L14.8197 9.42748Z"
              fill="#A1B1BA"
            />
          </svg>
        </span>
      </div>
      <span class="read">
        <span v-if="pages">{{ pages }} pages ∙ </span>
        <span v-if="publishDate">{{ publishDate }}</span>
      </span>
      <span class="ico ico-bookmark" @click.stop="handleBookmarkSession">
        <svg
          v-if="isBookMarked"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.333 2H4.66634C3.93301 2 3.33301 2.6 3.33301 3.33333V14L7.99967 12L12.6663 14V3.33333C12.6663 2.6 12.0663 2 11.333 2Z"
            fill="#A1B1BA"
          />
        </svg>
        <svg
          v-else
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.66699 2.66671C4.49018 2.66671 4.32061 2.73695 4.19559 2.86197C4.07056 2.98699 4.00033 3.15656 4.00033 3.33337V12.7046L7.61283 10.1242C7.84463 9.95865 8.15602 9.95865 8.38782 10.1242L12.0003 12.7046V3.33337C12.0003 3.15656 11.9301 2.98699 11.8051 2.86197C11.68 2.73695 11.5105 2.66671 11.3337 2.66671H4.66699ZM3.25278 1.91916C3.62785 1.54409 4.13656 1.33337 4.66699 1.33337H11.3337C11.8641 1.33337 12.3728 1.54409 12.7479 1.91916C13.1229 2.29423 13.3337 2.80294 13.3337 3.33337V14C13.3337 14.2498 13.1941 14.4785 12.972 14.5928C12.75 14.7071 12.4827 14.6877 12.2795 14.5425L8.00033 11.486L3.72115 14.5425C3.51794 14.6877 3.25065 14.7071 3.0286 14.5928C2.80656 14.4785 2.66699 14.2498 2.66699 14V3.33337C2.66699 2.80294 2.87771 2.29423 3.25278 1.91916Z"
            fill="#A1B1BA"
          />
        </svg>
      </span>
      <span class="ico ico-share">
        <svg
          @click.stop="openShare"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9997 1.99996C11.2633 1.99996 10.6663 2.59691 10.6663 3.33329C10.6663 4.06967 11.2633 4.66663 11.9997 4.66663C12.7361 4.66663 13.333 4.06967 13.333 3.33329C13.333 2.59691 12.7361 1.99996 11.9997 1.99996ZM9.33301 3.33329C9.33301 1.86053 10.5269 0.666626 11.9997 0.666626C13.4724 0.666626 14.6663 1.86053 14.6663 3.33329C14.6663 4.80605 13.4724 5.99996 11.9997 5.99996C10.5269 5.99996 9.33301 4.80605 9.33301 3.33329Z"
            fill="#A1B1BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.99967 6.66663C3.26329 6.66663 2.66634 7.26358 2.66634 7.99996C2.66634 8.73634 3.26329 9.33329 3.99967 9.33329C4.73605 9.33329 5.33301 8.73634 5.33301 7.99996C5.33301 7.26358 4.73605 6.66663 3.99967 6.66663ZM1.33301 7.99996C1.33301 6.5272 2.52692 5.33329 3.99967 5.33329C5.47243 5.33329 6.66634 6.5272 6.66634 7.99996C6.66634 9.47272 5.47243 10.6666 3.99967 10.6666C2.52692 10.6666 1.33301 9.47272 1.33301 7.99996Z"
            fill="#A1B1BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9997 11.3333C11.2633 11.3333 10.6663 11.9302 10.6663 12.6666C10.6663 13.403 11.2633 14 11.9997 14C12.7361 14 13.333 13.403 13.333 12.6666C13.333 11.9302 12.7361 11.3333 11.9997 11.3333ZM9.33301 12.6666C9.33301 11.1939 10.5269 9.99996 11.9997 9.99996C13.4724 9.99996 14.6663 11.1939 14.6663 12.6666C14.6663 14.1394 13.4724 15.3333 11.9997 15.3333C10.5269 15.3333 9.33301 14.1394 9.33301 12.6666Z"
            fill="#A1B1BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.42135 8.90698C5.60673 8.58886 6.01489 8.48125 6.33301 8.66663L10.333 11C10.6511 11.1853 10.7587 11.5935 10.5734 11.9116C10.388 12.2297 9.97982 12.3373 9.66171 12.152L5.6617 9.81864C5.34359 9.63326 5.23598 9.2251 5.42135 8.90698Z"
            fill="#A1B1BA"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5728 4.08815C10.7584 4.40615 10.651 4.81438 10.333 4.99996L6.33838 7.48488C6.02038 7.67045 5.61215 7.5631 5.42657 7.2451C5.24099 6.9271 5.34834 6.51887 5.66634 6.33329L9.66097 3.84838C9.97897 3.6628 10.3872 3.77015 10.5728 4.08815Z"
            fill="#A1B1BA"
          />
        </svg>
        <div class="share-popup" v-if="showSearch">
          <span @click.stop="shareToFacebook(slug)" class="ico ico-fb">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.1173 0H0.882667C0.395333 0 0 0.395333 0 0.882667V15.1173C0 15.6053 0.395333 16 0.882667 16H8.54533V9.804H6.45933V7.39H8.54533V5.60667C8.54533 3.54067 9.808 2.41667 11.6513 2.41667C12.5347 2.41667 13.294 2.48133 13.5153 2.51067V4.67067H12.2347C11.2347 4.67067 11.04 5.15133 11.04 5.85133V7.392H13.4293L13.1193 9.812H11.04V16H15.1167C15.6053 16 16 15.6053 16 15.1173V0.882667C16 0.395333 15.6053 0 15.1173 0Z"
                fill="#A1B1BA"
              />
            </svg>
          </span>
          <span @click.stop="shareToTwitter(slug)" class="ico ico-tw">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M14.2857 -0.0183105H1.71429C0.767857 -0.0183105 0 0.751546 0 1.70044V14.3046C0 15.2535 0.767857 16.0234 1.71429 16.0234H14.2857C15.2321 16.0234 16 15.2535 16 14.3046V1.70044C16 0.751546 15.2321 -0.0183105 14.2857 -0.0183105ZM12.5393 5.66789C12.5464 5.76815 12.5464 5.87199 12.5464 5.97225C12.5464 9.07674 10.1893 12.6539 5.88214 12.6539C4.55357 12.6539 3.32143 12.2672 2.28571 11.6012C2.475 11.6226 2.65714 11.6298 2.85 11.6298C3.94643 11.6298 4.95357 11.2574 5.75714 10.6272C4.72857 10.6057 3.86429 9.92895 3.56786 8.99796C3.92857 9.05168 4.25357 9.05168 4.625 8.955C3.55357 8.73657 2.75 7.79126 2.75 6.64901V6.62036C3.06071 6.79582 3.425 6.90324 3.80714 6.91756C3.48587 6.7033 3.22249 6.41263 3.04053 6.07149C2.85856 5.73035 2.76365 5.34935 2.76429 4.96248C2.76429 4.52563 2.87857 4.12459 3.08214 3.77726C4.23571 5.20239 5.96786 6.13338 7.91071 6.23364C7.57857 4.64022 8.76786 3.34757 10.1964 3.34757C10.8714 3.34757 11.4786 3.63045 11.9071 4.08879C12.4357 3.98852 12.9429 3.79158 13.3929 3.52303C13.2179 4.0673 12.85 4.52563 12.3643 4.81567C12.8357 4.76554 13.2929 4.63306 13.7143 4.45044C13.3964 4.91951 12.9964 5.33488 12.5393 5.66789Z"
                  fill="#A1B1BA"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span @click.stop="shareToLinkedin(slug)" class="ico ico-li">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.6313 13.6347H11.262V9.922C11.262 9.03667 11.244 7.89733 10.0273 7.89733C8.792 7.89733 8.60333 8.86067 8.60333 9.85667V13.6347H6.234V6H8.51V7.04067H8.54067C8.85867 6.44067 9.632 5.80733 10.7873 5.80733C13.188 5.80733 13.632 7.38733 13.632 9.444V13.6347H13.6313ZM3.558 4.95533C2.79533 4.95533 2.18267 4.338 2.18267 3.57867C2.18267 2.82 2.796 2.20333 3.558 2.20333C4.318 2.20333 4.934 2.82 4.934 3.57867C4.934 4.338 4.31733 4.95533 3.558 4.95533ZM4.746 13.6347H2.37V6H4.746V13.6347ZM14.8167 0H1.18067C0.528 0 0 0.516 0 1.15267V14.8473C0 15.4847 0.528 16 1.18067 16H14.8147C15.4667 16 16 15.4847 16 14.8473V1.15267C16 0.516 15.4667 0 14.8147 0H14.8167Z"
                fill="#A1B1BA"
              />
            </svg>
          </span>
          <span
            v-b-popover.top.hover="popupText"
            @click.stop="copytoClipboard(slug)"
            class="ico ico-copy"
            @mouseleave="changePopupText"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.33301 6.66659C6.96482 6.66659 6.66634 6.96506 6.66634 7.33325V13.3333C6.66634 13.7014 6.96482 13.9999 7.33301 13.9999H13.333C13.7012 13.9999 13.9997 13.7014 13.9997 13.3333V7.33325C13.9997 6.96506 13.7012 6.66659 13.333 6.66659H7.33301ZM5.33301 7.33325C5.33301 6.22868 6.22844 5.33325 7.33301 5.33325H13.333C14.4376 5.33325 15.333 6.22868 15.333 7.33325V13.3333C15.333 14.4378 14.4376 15.3333 13.333 15.3333H7.33301C6.22844 15.3333 5.33301 14.4378 5.33301 13.3333V7.33325Z"
                fill="#A1B1BA"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.66699 2.00008C2.49018 2.00008 2.32061 2.07032 2.19559 2.19534C2.07056 2.32037 2.00033 2.48994 2.00033 2.66675V8.66675C2.00033 8.84356 2.07056 9.01313 2.19559 9.13815C2.32061 9.26318 2.49018 9.33342 2.66699 9.33342H3.33366C3.70185 9.33342 4.00033 9.63189 4.00033 10.0001C4.00033 10.3683 3.70185 10.6667 3.33366 10.6667H2.66699C2.13656 10.6667 1.62785 10.456 1.25278 10.081C0.877706 9.70589 0.666992 9.19718 0.666992 8.66675V2.66675C0.666992 2.13632 0.877706 1.62761 1.25278 1.25253C1.62785 0.877462 2.13656 0.666748 2.66699 0.666748H8.66699C9.19743 0.666748 9.70613 0.877462 10.0812 1.25253C10.4563 1.62761 10.667 2.13631 10.667 2.66675V3.33341C10.667 3.7016 10.3685 4.00008 10.0003 4.00008C9.63214 4.00008 9.33366 3.7016 9.33366 3.33341V2.66675C9.33366 2.48994 9.26342 2.32037 9.1384 2.19534C9.01337 2.07032 8.8438 2.00008 8.66699 2.00008H2.66699Z"
                fill="#A1B1BA"
              />
            </svg>
          </span>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Share from "@/mixins/ShareCornerSocial.js";
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  name: "SessionCard",
  components: {
    TipTapOutput
  },
  props: {
    session: Object,
    index: Number,
    bookMarks: Array,
    followedBloggers: Array,
    showRanking: Boolean
  },
  mixins: [Share],
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    imgURL() {
      return this.session.doc ? this.session.doc.imgURL : "";
    },
    slug() {
      return this.session.slug ? this.session.slug : "";
    },
    pages() {
      return this.session.doc ? this.session.doc.pages : "";
    },
    publishDate() {
      return this.session
        ? this.session._published_at
          ? this.getDate(this.session._published_at.toDate())
          : ""
        : "";
    },
    isBookMarked() {
      /*let isBookMarked = false;
      this.bookMarks.forEach(bookmark => {
        if (bookmark.id == this.session.id) {
          isBookMarked = true;
        }
      });*/
      const isBookMarked = true;
      return isBookMarked;
    },
    isFollowed() {
      /*let isFollowed = false;
      this.followedBloggers.forEach(blogger => {
        console.log(blogger);
        if (blogger.bloggerId == this.session.blogger.bloggerId) {
          isFollowed = true;
        }
      });*/
      const isFollowed = true;
      return isFollowed;
    }
  },
  methods: {
    handleSessionClick() {
      this.$router.push(`/sessions/${this.session.slug}`);
    },
    handleAuthorProfileClick() {
      if (this.bloggerProfileName)
        this.$router.push(`/author/crew/@${this.bloggerProfileName}`);
    },
    getDate(date) {
      return moment(date).format("DD MMMM");
    },
    openShare() {
      this.showSearch = !this.showSearch;
    },
    handleBookmarkSession() {
      if (this.isBookMarked) {
        let data = {
          type: "remove",
          blog: this.session
        };
        this.$emit("bookmark-session", data);
      } else {
        let data = {
          type: "add",
          blog: this.session
        };
        this.$emit("bookmark-session", data);
      }
    },
    handleCollectCornerSession() {
      if (this.isFollowed) {
        let data = {
          type: "unfollow",
          blogger: this.session.blogger
        };
        this.$emit("followBlogger", data);
      } else {
        let data = {
          type: "follow",
          blogger: this.session.blogger
        };
        this.$emit("followBlogger", data);
      }
    }
  },
  data() {
    return {
      sessionTitle: this.session && this.session.doc && this.session.doc.session && this.session.doc.session.title ?
          this.session.doc.session.title :'HeartBeatFam Session',
      sessionDescription: this.session && this.session.doc && this.session.doc.session && this.session.doc.session.description ?
          this.session.doc.session.description :'An exciting HeartBeatFam Session',
      bloggerFullname: this.session.blogger
          ? `${this.session.blogger.firstname}   ${this.session.blogger.lastname}`
          : "",
      bloggerImgURL: this.session.blogger
          ? this.session.blogger.imgURL
          : "",
      bloggerProfileName: this.session.blogger
          ? this.session.blogger.profileName
          : "",
      isSpiritual: this.session
          ? this.session.doc
              ? this.session.doc.spheres
                  ? this.session.doc.spheres.includes("s")
                  : false
              : false
          : false,
      isHealth: this.session
          ? this.session.doc
              ? this.session.doc.spheres
                  ? this.session.doc.spheres.includes("h")
                  : false
              : false
          : false,
      isEducation: this.session
          ? this.session.doc
              ? this.session.doc.spheres
                  ? this.session.doc.spheres.includes("e")
                  : false
              : false
          : false,
      isFinance: this.session
          ? this.session.doc
              ? this.session.doc.spheres
                  ? this.session.doc.spheres.includes("f")
                  : false
              : false
          : false,
      showSearch: false
    };
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.wrapper {
  cursor: pointer;
  width: 100%;
  padding: 12px;
  background: #ffffff;
  border-radius: 12px;
  user-select: none;
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.08);
  }
  .level {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    color: #a1b1ba;
    margin-bottom: 4px;
    user-select: none;
  }
  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    color: #474d52;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .details {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 16px;

    .categories {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .ico {
        margin-right: 8px;
      }
    }
    .read {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
      margin-right: 8px;
      margin-top: 2px;
    }
    .ico-bookmark {
      margin-right: 8px;
      cursor: pointer;
      &:hover {
        transform: scale(1.07);
      }
    }
    .ico-share {
      cursor: pointer;
      position: relative;
      svg {
        &:hover {
          transform: scale(1.07);
        }
      }
      &:active {
        transform: none;
      }
      .share-popup {
        position: absolute;
        width: 150px;
        height: 45px;
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        top: 100%;
        left: 80%;
        z-index: 3;
        &:hover {
          transform: none;
        }
      }
    }
  }
  .btn-follow {
    z-index: 0;
    border: 1px solid #474d52;
    box-sizing: border-box;
    border-radius: 4px;
    width: 54px;
    height: 20px;
    padding: 0px;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 14px;
    transition: 0.2s ease;
    &:hover {
      background-color: #474d52;
      color: #fff;
      &:after,
      &:before {
        content: none;
      }
    }
  }
  .followed {
    width: 65px;
    color: #fff;
    background: #474d52;
  }
  .corner-profile {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    user-select: none;
    grid-column-gap: 8px;
    img {
      cursor: pointer;
      height: 150px;
      width: 150px;
      border-radius: 5%;
      border-style: none;
      object-fit: cover;
    }
    .name {
      cursor: pointer;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 26px;
      color: #474d52;
      margin: 0;
    }
  }
}
</style>
